import { queryOptions, useQuery } from '@tanstack/react-query';

import { feedsApi } from '../api/feeds-api';

import { feedKeys } from './feed-keys';

/** Built live from the published catalogue, so counts change as products are published. */
export function feedStatusQueryOptions(storeId: string) {
  return queryOptions({
    queryKey: feedKeys.status(storeId),
    queryFn: () => feedsApi.status(storeId),
  });
}

export function useFeedStatus(storeId: string) {
  return useQuery(feedStatusQueryOptions(storeId));
}
